<template>
  <v-menu 
    v-model="menu"
    :close-on-content-click="false"
    :nudge-width="200"
    offset-x
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        v-on="on"
      >
        <v-icon color="primary">
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-card-text class="font-weight-light pb-0 custom-background">
        Allowance Detail
      </v-card-text>
      <v-card-text class="pt-0 custom-background">
        Editing <span class="font-weight-bold">{{ localPayroll.allowance_penalty_type.name.toUpperCase() }}</span> Allowance Detail
      </v-card-text>

      <v-container>
        <v-row no-gutters>
          <v-col cols="12">
            <v-text-field
              v-model="localPayroll.amount"
              v-validate="'required|twoDecimalValue'"
              type="number"
              :error-messages="errors.collect('amount')"
              data-vv-name="amount"                
              data-vv-as="amount"  
              prefix="RM"          
              label="Amount"
            />
          </v-col>
          <v-col cols="12">
            <v-textarea
              v-model="localPayroll.remarks"
              v-validate="'max:1000'"
              :rows="2"
              :error-messages="errors.collect('remarks')"     
              data-vv-name="remarks"           
              data-vv-as="remarks"
              label="Remarks"
            />
          </v-col>
        </v-row> 
      </v-container>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="menu = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
  import Big from 'big.js'
  export default {
    inject: ['$validator'],
    props: {
      payroll: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        menu: null,
        progressing: false,
        localPayroll: null,
      }
    },
    watch: {
      payroll: {
        immediate: true,
        handler (value) {
          if (value) {
            this.localPayroll = { ...this.payroll }
            this.localPayroll.amount = (this.payroll.amount / 100).toFixed(2)
          }
        },
      },
    },
    mounted () {
      let _this = this

      this.$validator.extend('twoDecimalValue', {
        getMessage (field, args) {
          return 'Only 2 Decimals are allowed'
        },
        validate (value, args) {
          return _this.isValidNumbers(value)
        },
      })
    },
    methods: {
      submitForm () {
        this.$validator.validate('amount', this.localPayroll.amount)
          .then(allowancePenaltyType => {
            if (!allowancePenaltyType) return false

            this.setProgressing(true)

            if (this.localPayroll.amount < 0) { this.localPayroll.amount = 0 - this.localPayroll.amount }
            this.$api.salaryDetails().update(this.localPayroll.id, this.prepareFormData())
              .then(res => {
                this.$emit('updated')
                this.$snack({ message: 'Allowance succesfully updated' })
                
                this.menu = false
                this.setProgressing(false)
              }).catch(() => {
                this.$snack({ 
                  color: 'error',
                  message: 'Failed to update allowance', 
                })
              })
          })
      },
      setProgressing (status) {
        this.progressing = status
      },
      prepareFormData () {
        return {
          amount: this.localPayroll.amount * 100,
          remarks: this.localPayroll.remarks,
        }
      },

      isValidNumbers (value) {
        return (new Big(value).times(10000) % 100 === 0)
      },
    },
  }
</script>

<style  scoped>
.custom-background{
  background-color:#5cb860 ;
  color:white !important
}
</style>
